export default __webpack_public_path__ + "static/er-6c81def9c473b2a3a274eca255a84f70.jpeg";